import { Injectable } from '@angular/core';
import { ApiConfigService } from './api-config.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MaterialItem } from '../../models/material.interface';

@Injectable({
  providedIn: 'root'
})
export class MaterialService {
  private get apiUrl(): string { return `${this.apiConfig.apiUrl}/materials`; }

  constructor(private http: HttpClient, private apiConfig: ApiConfigService) {}

  getMaterials(): Observable<MaterialItem[]> {
    return this.http.get<MaterialItem[]>(this.apiUrl);
  }

  createMaterial(data: { name: string; description?: string }): Observable<MaterialItem> {
    return this.http.post<MaterialItem>(this.apiUrl, data);
  }

  deleteMaterial(id: string): Observable<{ message: string }> {
    return this.http.delete<{ message: string }>(`${this.apiUrl}/${id}`);
  }
}



